// extracted by mini-css-extract-plugin
export default {"chartWrap":"chart_chartWrap__ywfBO"};